import { create } from "zustand"

import { ANALYTIC_EVENTS } from "../../../../util/analytics"
import { trackAnalyticEvent } from "../../../../util/analytics"

export enum DoterAIInfoStep {
  STEP_1,
  STEP_2,
  STEP_3,
}

interface DoterAIInfoModalStore {
  isOpen: boolean
  onClose: () => void
  onOpen: (isFTUX?: boolean) => void
  currentStep: DoterAIInfoStep
  setCurrentStep: (currentStep: DoterAIInfoStep) => void
  isOnboarding: boolean
}

export const useDoterAIInfoModalStore = create<DoterAIInfoModalStore>(
  (set) => ({
    isOpen: false,
    onClose: () => set({ isOpen: false }),
    onOpen: (isOnboarding = false) => {
      trackAnalyticEvent(ANALYTIC_EVENTS.SHOW_DOTER_CHAT_INFORMATIONAL)
      set({
        isOpen: true,
        currentStep: DoterAIInfoStep.STEP_1,
        isOnboarding,
      })
    },
    currentStep: DoterAIInfoStep.STEP_1,
    setCurrentStep: (currentStep: DoterAIInfoStep) => set({ currentStep }),
    isOnboarding: false,
  })
)
